"use strict";
/**
 * The press and hold on a pad's parked count that copies its parked taps (ai/nba/N8-taps/PLAN.md
 * §19a.5), shared by Pad 1 and the football pad. The copy runs on the release after a full hold,
 * not on the timer: iOS writes the clipboard only inside a user gesture.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParkedHold = exports.PARKED_HOLD_MS = void 0;
exports.copyParked = copyParked;
exports.PARKED_HOLD_MS = 600;
class ParkedHold {
    constructor() {
        this.timer = null;
        this.held = false;
        this.el = null;
        /** The pressing pointer: another finger's release or cancel is not this hold's. */
        this.pointerId = null;
    }
    /** pointerdown: true when it began a hold on a parked count (the caller handles nothing else). */
    press(event) {
        const el = event.target?.closest?.(".tap-parked");
        if (!el)
            return false;
        event.preventDefault(); // no callout or selection taking the press over
        this.reset();
        this.el = el;
        this.pointerId = event.pointerId ?? null;
        this.timer = window.setTimeout(() => {
            this.timer = null;
            this.held = true;
            el.classList.add("tap-parked-held");
        }, exports.PARKED_HOLD_MS);
        return true;
    }
    mine(event) {
        return this.el !== null && (event.pointerId ?? null) === this.pointerId;
    }
    /** pointerup: true when the pressing pointer held long enough to copy. */
    release(event) {
        if (!this.mine(event))
            return false;
        const held = this.held;
        this.reset();
        return held;
    }
    /** pointercancel: ends the hold only for the pressing pointer. */
    cancel(event) {
        if (this.mine(event))
            this.reset();
    }
    reset() {
        if (this.timer !== null)
            window.clearTimeout(this.timer);
        this.timer = null;
        this.held = false;
        this.el?.classList.remove("tap-parked-held");
        this.el = null;
        this.pointerId = null;
    }
}
exports.ParkedHold = ParkedHold;
/** Writes the parked taps to the clipboard, resolving to the status line's message. Call inside the gesture. */
function copyParked(queue) {
    const n = queue.parked.length;
    const failed = (error) => ({ ok: false, text: `copy failed: ${error?.message ?? String(error)}` });
    try {
        if (!navigator.clipboard?.writeText)
            return Promise.resolve(failed(new Error("no clipboard")));
        return navigator.clipboard.writeText(queue.parkedJson()).then(() => ({ ok: true, text: `copied ${n} parked tap${n === 1 ? "" : "s"}` }), failed);
    }
    catch (error) {
        return Promise.resolve(failed(error));
    }
}
